export default __webpack_public_path__ + "static/media/ribbit-demo.d4d10081.gif";